<div class="card shadow-sm border-0 support-context-card">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-start gap-3">
      <div>
        <h6 class="fw-bold mb-1">{{ title }}</h6>
        <div class="text-muted small mb-3">
          {{ subtitle }}
        </div>
      </div>

      <a [routerLink]="helpCenterLink" class="btn btn-sm btn-outline-secondary">
        Help Center
      </a>
    </div>

    <div class="d-flex flex-wrap gap-2 mb-2">
      <button
        *ngFor="let question of quickQuestions"
        type="button"
        class="btn btn-sm btn-outline-primary"
        (click)="openSupport(question)">
        {{ question }}
      </button>
    </div>

    <div *ngIf="suggestedQuestion" class="small text-muted">
      Suggested support prompt: <strong>{{ suggestedQuestion }}</strong>
    </div>
  </div>
</div>